import { createApiInstance } from "./apiClient";

const url = process.env.REACT_APP_ORDER_API_URL;

export const createAddress = async (addressData) => {
	try {
		const instance = createApiInstance({ baseURL: `${url}/api/address/`, retry: true });

		return await instance
			.post(``, addressData)
			.then((response) => {
				if (response.status === 204 || response.status === 200)
					return {
						error: false,
						success: true,
						message: response.data.message,
						data: response.data.data
					};
				else
					return {
						error: true,
						success: false,
						message: response.data.message
					};
			})
			.catch((error) => {
				if (error.response) {
					console.error("Server Error:", error.response.status);
				}
				else if (error.request) {
					console.error("Network Error:", error.request);
				}
				else {
					console.error("Error:", error.message);
				}
			});
	}
	catch (error) {
		console.error(error);
		return {
			error: true,
			success: false,
			message: "Something went wrong. Please try again."
		};
	}
};
